// extracted by mini-css-extract-plugin
export var closeButton = "_ma-1";
export var closeX = "_ma-3";
export var container = "_ma-0";
export var image = "_ma-2";